/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrderDiscountFrequencyQualifier = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY'
} as const;
export type OrderDiscountFrequencyQualifier = typeof OrderDiscountFrequencyQualifier[keyof typeof OrderDiscountFrequencyQualifier];


export function instanceOfOrderDiscountFrequencyQualifier(value: any): boolean {
    for (const key in OrderDiscountFrequencyQualifier) {
        if (Object.prototype.hasOwnProperty.call(OrderDiscountFrequencyQualifier, key)) {
            if (OrderDiscountFrequencyQualifier[key as keyof typeof OrderDiscountFrequencyQualifier] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrderDiscountFrequencyQualifierFromJSON(json: any): OrderDiscountFrequencyQualifier {
    return OrderDiscountFrequencyQualifierFromJSONTyped(json, false);
}

export function OrderDiscountFrequencyQualifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDiscountFrequencyQualifier {
    return json as OrderDiscountFrequencyQualifier;
}

export function OrderDiscountFrequencyQualifierToJSON(value?: OrderDiscountFrequencyQualifier | null): any {
    return value as any;
}

export function OrderDiscountFrequencyQualifierToJSONTyped(value: any, ignoreDiscriminator: boolean): OrderDiscountFrequencyQualifier {
    return value as OrderDiscountFrequencyQualifier;
}

